import React from 'react';

import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type StepItem = {
  label: string;
  highlight?: boolean;
};

type Props = {
  steps: StepItem[];
};

/**
 * ステップフロー（縦方向の矢印付き）
 */
const WorkflowStepFlow: React.FC<Props> = ({ steps }) => {
  return (
    <Stack spacing={0} alignItems="center">
      {steps.map((step, index) => (
        <React.Fragment key={index}>
          <Box
            sx={{
              border: 1,
              borderColor: step.highlight ? 'primary.main' : 'divider',
              borderRadius: 1.5,
              px: 2,
              py: 1,
              bgcolor: step.highlight
                ? (theme) =>
                    theme.palette.mode === 'dark'
                      ? 'rgba(25, 118, 210, 0.12)'
                      : 'rgba(25, 118, 210, 0.06)'
                : 'transparent',
              minWidth: 200,
              textAlign: 'center',
            }}
          >
            <Typography
              variant="body2"
              fontWeight={step.highlight ? 600 : 400}
              color={step.highlight ? 'primary.main' : 'text.primary'}
            >
              {step.label}
            </Typography>
          </Box>
          {index < steps.length - 1 && (
            <ArrowDownwardIcon sx={{ fontSize: 18, color: 'text.disabled', my: 0.25 }} />
          )}
        </React.Fragment>
      ))}
    </Stack>
  );
};

export default WorkflowStepFlow;
